var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.62,3.98c-1.02-0.52-2.26-0.12-2.78,0.9c-0.52,1.02-0.12,2.26,0.9,2.78c4.97,2.55,8.06,7.59,8.06,13.15 c0,8.16-6.64,14.79-14.79,14.79c-8.16,0-14.79-6.64-14.79-14.79c0-5.57,3.09-10.61,8.06-13.15c1.02-0.52,1.42-1.77,0.9-2.78 c-0.52-1.02-1.77-1.42-2.78-0.9C5.02,7.24,1.07,13.69,1.07,20.82c0,10.44,8.49,18.93,18.93,18.93s18.93-8.49,18.93-18.93 C38.93,13.69,34.98,7.24,28.62,3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.63c1.14,0,2.07-0.93,2.07-2.07V2.32c0-1.14-0.93-2.07-2.07-2.07c-1.14,0-2.07,0.93-2.07,2.07v13.24 C17.93,16.7,18.86,17.63,20,17.63z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIcon2);
export default __webpack_public_path__ + "static/media/gnb_icon_2.8e57c15f9e1881a1716abdf0b2796a70.svg";
export { ForwardRef as ReactComponent };